import { Icon } from "leaflet";
import { useEffect, useRef, useState } from "react";
import { LayersControl, Marker, Polyline, Popup, useMap } from "react-leaflet";
import { useMapStore } from "../../store/mapStore";
import Legend from "../../components/legends/legends";

const { Overlay } = LayersControl;
const limeOptions = { color: 'red' }
const MissionWaypointMapView = () => {
    const map = useMap()
    const polyref = useRef(null)

    const [missionWaypoints, setMissionWaypoints] = useState([])
    const { missionPlanningWaypoints } = useMapStore((state) => state)

    useEffect(() => {
        setMissionWaypoints(missionPlanningWaypoints?.map((waypoint) => {
            return [waypoint.lat, waypoint.lng]
        }))
    }, [missionPlanningWaypoints])

    useEffect(() => {
        const polyline = polyref.current;
        if (Object.keys(polyline?.getBounds())?.length > 0) {
            map.fitBounds(polyline?.getBounds());
        }
    }, [missionWaypoints])

    const LegendData = [
        {
            title: "Starting Position",
            img: "https://icon-library.com/images/map-marker-icon/map-marker-icon-18.jpg"
        },
        {
            title: "Ending Position",
            img: "https://icon-library.com/images/icon-markers/icon-markers-4.jpg"
        },
        {
            title: "Way Point",
            img: "https://icon-library.com/images/google-map-marker-icon/google-map-marker-icon-9.jpg"
        }
    ]
    return (
        <><Overlay checked name="Overlay Layer">
            <Polyline
                ref={polyref}
                pathOptions={limeOptions}
                positions={missionWaypoints?.length > 0 && missionWaypoints || []}
            >
                {missionWaypoints?.map((pos, index) => {
                    return index === 0 ? (
                        <Marker key={index} position={missionWaypoints?.length > 0 && missionWaypoints[0]} icon={new Icon({
                            iconUrl: "https://icon-library.com/images/map-marker-icon/map-marker-icon-18.jpg", iconSize: [30, 30]
                        })}>
                            <Popup>
                                <div className="font-extrabold">Starting Position</div>
                                <div>{pos[0]},{pos[1]}</div>
                            </Popup>
                        </Marker>
                    ) : index === missionWaypoints?.length - 1 ? (
                        <Marker key={index} position={missionWaypoints?.length > 0 && missionWaypoints[missionWaypoints?.length - 1]} icon={new Icon({ iconUrl: "https://icon-library.com/images/icon-markers/icon-markers-4.jpg", iconSize: [30, 30] })}>
                            <Popup>
                                <div className="font-extrabold">Ending Position</div>
                                <div>{pos[0]},{pos[1]}</div>
                            </Popup>
                        </Marker>
                    ) : <Marker key={index} position={pos} icon={new Icon({ iconUrl: "https://icon-library.com/images/google-map-marker-icon/google-map-marker-icon-9.jpg", iconSize: [30, 30] })}>
                        <Popup>
                            <div className="font-extrabold">Way Point</div>
                            <span >{pos[0]},{pos[1]}</span>
                        </Popup>
                    </Marker>;
                })}
            </Polyline>
            <Legend data={LegendData} />
        </Overlay>
        </>
    )
}

export default MissionWaypointMapView